/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_PlaceholderInputs */

const en_filter_placeholder = /** @type {(inputs: Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter with type:bug, priority:p0, area:auth or any text`)
};

const de_filter_placeholder = /** @type {(inputs: Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtern mit type:bug, priority:p0, area:auth oder beliebigem Text`)
};

/**
* | output |
* | --- |
* | "Filter with type:bug, priority:p0, area:auth or any text" |
*
* @param {Filter_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_placeholder = /** @type {((inputs?: Filter_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_placeholder(inputs)
	return en_filter_placeholder(inputs)
});